import React, { Component } from "react";
import Modal from "react-modal";
import "./../css/LoginSSO.css";
import ForgottenPassword from "./forgottenPassword/ForgottenPassword";
import ChangePassword from "./forgottenPassword/ChangePassword";
import ChangePasswordByUser from "./forgottenPassword/ChangePasswordByUser";
import Axios from "axios";
var base64LogoImg = "";
var base64BackgroundImg = "";
Modal.setAppElement("body");
class LoginSSO extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      error: "",
      stage: 1,
      authServerUrl: "",
      resourceServerUrl: "",
      userBeforeLoggedIn: null,
      passwordChangeRequired: false,
      userWhoWantsToChangePassword: null,
      newUserChangePassword: false,
      clicked: false,
      connectedUsers: false,
      imageData: "",
      extensionOfImg: "",
      labelNamesList: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.setNewUserChangePassword = this.setNewUserChangePassword.bind(this);

    this.loadLabels = this.loadLabels.bind(this);
    this.composingLabel = this.composingLabel.bind(this);
  }
  loadLabels(languageCode) {
    Axios({
      method: "POST",
      url: "labelname/listAllByPrefix",
      params: {
        code: languageCode,
        labelprefix: "sportOauthLabel.",
      },
    }).then((response) => {
      console.log(response);
      if (response.status === 200) {
        let list = [];
        response.data.forEach((element) => {
          list[element.labelId] = element.name;
        });
        this.setState({
          labelNamesList: list,
        });
      }
    });
  }

  composingLabel(labelId, defaultLabel, hideDots) {
    let dontShowDots = hideDots !== undefined ? hideDots : true;
    let label = defaultLabel;
    if (this.state.labelNamesList && this.state.labelNamesList[labelId]) {
      label = this.state.labelNamesList[labelId];
    }
    if (dontShowDots === false) {
      label = label + ": ";
    }
    return label;
  }

  setNewUserChangePassword() {
    this.setState({
      userWhoWantsToChangePassword: null,
      newUserChangePassword: false,
      password: "",
    });
    this.forceUpdate();
  }

  handleChange(event) {
    const { value, name } = event.target;
    this.setState({ [name]: value });
  }

  componentDidMount() {
    this.loadAuthorizationServerUrl();
    this.getImage("LemanikLogo");
    this.getImage("LemanikBackground");
    this.loadLabels("EN");
  }
  getImage(configName) {
    var imageData = [];
    var extensionOfImg = [];

    fetch("config/getImage?name=" + configName, {
      method: "POST",
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        imageData[configName] = data.image;
        extensionOfImg[configName] = data.value;
        this.setState(
          {
            imageData: imageData,
            extensionOfImg: extensionOfImg,
          },
          function () {
            //console.log(this.state.imageData,this.state.extensionOfImg)
          }
        );
      });
  }
  loadAuthorizationServerUrl() {
    fetch("server/url?serverName=AuthorizationServer", {
      method: "POST",
    })
      .then((result) => {
        return result.json();
      })
      .then((data) => {
        this.setState({
          authServerUrl: data.value,
        });
      });
  }

  handleOpenModal() {
    this.setState({ showModal: true });
  }

  handleCloseModal() {
    this.setState({ showModal: false });
  }

  handleSubmit(event) {
    event.preventDefault();
    var parent = this;
    let bodyData =
      "username=" +
      this.state.username +
      "&password=" +
      this.state.password +
      "&dbParam=true";
    let self = this;

    if (this.state.username == "" && this.state.password == "") {
      this.setState({ error: "Wrong username or password" });
      alert("Enter user name or password");
    } else {
      fetch(
        "changePasswordRequired?username=" +
          this.state.username +
          "&password=" +
          this.state.password,
        {
          method: "POST",
        }
      )
        .then((result) => {
          return result.json();
        })
        .then((data) => {
          if (data["message"] !== null && data["message"] !== undefined) {
            parent.setState({ error: data["message"] });
          } else {
            if (data["status"] !== "DS" && data["status"] !== "P") {
              this.setState({
                passwordChangeRequired: data["changePasswordRequired"],
                userWhoWantsToChangePassword: data,
              });
              if (!this.state.passwordChangeRequired) {
                fetch("maxNumberOfUsers", {
                  method: "POST",
                })
                  .then((result) => {
                    return result.json();
                  })
                  .then((data) => {
                    this.setState({ connectedUsers: data });
                    if (this.state.connectedUsers) {
                      fetch(parent.state.authServerUrl, {
                        method: "POST",
                        redirect: "follow",
                        headers: new Headers({
                          Accept:
                            "text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8",
                          "Content-Type": "application/x-www-form-urlencoded",
                        }),
                        body: bodyData,
                        credentials: "include",
                        //credentials: 'same-origin',
                      })
                        .then(function (response) {
                          let errorUrl = self.state.authServerUrl + "?error";
                          console.log("ERROR URL: ", errorUrl);
                          if (response.url === errorUrl) {
                            parent.setState({ error: "Wrong password" });
                          } else {
                            fetch(
                              "userupdate/updateConnectionDate?username=" +
                                parent.state.username,
                              {
                                method: "GET",
                                credentials: "include",
                                redirect: "follow",
                              }
                            ).then((result) => {
                              window.location.href = response.url;
                            });
                          }
                        })
                        .catch((err) => console.error("Caught error: ", err));
                      console.log("stage is " + this.state.stage);
                    } else {
                      parent.setState({
                        error: "Max number of users is reached!",
                      });
                    }
                  });
              } else {
                if (
                  data["newUserChangePassword"] === true &&
                  data["changePasswordRequired"]
                ) {
                  if (data["passwordIsGood"] === true) {
                    this.setState({
                      newUserChangePassword: data["newUserChangePassword"],
                      userWhoWantsToChangePassword: data,
                      passwordChangeRequired: false,
                    });
                    this.forceUpdate();
                  } else {
                    this.setState({
                      passwordChangeRequired: false,
                    });
                    this.forceUpdate();
                    parent.setState({ error: "Wrong password" });
                  }
                }
              }
            } else {
              parent.setState({
                error:
                  data["status"] === "DS"
                    ? "User is disabled"
                    : "User is pending" + " and can't log in.",
              });
            }
          }
        });
    }
  }

  handleClick() {
    console.log("KLIK");
    this.setState({
      clicked: true,
      passwordChangeRequired: false,
    });
  }

  render() {
    if (
      this.state.imageData["LemanikLogo"] &&
      this.state.extensionOfImg["LemanikLogo"]
    ) {
      base64LogoImg =
        "data:image/" +
        this.state.extensionOfImg["LemanikLogo"] +
        ";base64," +
        this.state.imageData["LemanikLogo"];
    }
    if (
      this.state.imageData["LemanikBackground"] &&
      this.state.extensionOfImg["LemanikBackground"]
    ) {
      base64BackgroundImg =
        "data:image/" +
        this.state.extensionOfImg["LemanikBackground"] +
        ";base64," +
        this.state.imageData["LemanikBackground"];
    }
    return (
      <div
        className="twoFactorAuthenticationContainer"
        style={{ backgroundImage: "url(" + base64BackgroundImg + ")" }}>
        {base64LogoImg !== "" && (
          <div className="textSegment">
            <img src={base64LogoImg} className="authenticationImage" />
          </div>
        )}
        <div className="loginSegment">
          <div className="loginSide">
            <h4 className="formTitle">
              {" "}
              <span className="errorMsg">{this.state.error}</span>
              <br /> Log in to your account:
            </h4>
            <form onSubmit={this.handleSubmit}>
              <div className="inputField">
                <img
                  src={require("../images/male-user.svg")}
                  className="inputIcon"
                />
                <input
                  name="username"
                  type="text"
                  value={this.state.username}
                  onChange={this.handleChange}
                  placeholder="Username"
                  className="loginInput"
                />
              </div>
              <div className="inputField">
                <img
                  src={require("../images/lock.svg")}
                  className="inputIcon"
                />
                <input
                  name="password"
                  type="password"
                  value={this.state.password}
                  onChange={this.handleChange}
                  placeholder="Password"
                  className="loginInput"
                />
              </div>
              <input
                type="submit"
                value="Log in"
                className="loginButtonSSO"
                onClick={this.handleClick}
              />
            </form>
            <ChangePassword
              composingLabel={this.composingLabel}
              oldPassword={this.state.password}
              setNewUserChangePassword={this.setNewUserChangePassword}
              userData={this.state.userWhoWantsToChangePassword}
              passwordChangeRequired={this.state.passwordChangeRequired}
            />
            <ChangePasswordByUser
              composingLabel={this.composingLabel}
              oldPassword={this.state.password}
              setNewUserChangePassword={this.setNewUserChangePassword}
              newUserChangePassword={this.state.newUserChangePassword}
              userData={this.state.userWhoWantsToChangePassword}
            />
            <ForgottenPassword
              composingLabel={this.composingLabel}
              classForThemeColor={"forgotPassLink"}
            />
          </div>

          <div className="registerSide">
            <h3>Are you new to MozaIK?</h3>
            <p>
              MozaIK is a modular solution that meets the business needs of
              front-end users. Based on a powerful technical layer, MozaIK
              covers broad functional requirements, including:
            </p>
            <ul>
              <li>Authoring &amp; Documentary Suite (MozaIK OMS)</li>
              <li>
                Relationship &amp; Marketing Management Suite (MozaIK CRM)
              </li>
            </ul>
            <button className="registerButton">Register now!</button>
          </div>
        </div>
      </div>
    );
  }
}
export default LoginSSO;



// WEBPACK FOOTER //
// ./src/main/resources/js/components/LoginSSO.js